import "../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from 'views/generic.view.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../templates/organization.template.htm';
import 'dhtmlxMessage';
import Model from '../models/organizations.model.ts';
import i18n  from 'l10n';

export default GenericView.extend({
	//Here, we set the id of the element, in which we put the template of the specific view
    el: $("#container"),
    //Set the element type from the above setup
	tagName: 'div',
	template: Handlebars.compile(Template),
	superInitialize: GenericView.prototype.initialize,
	Model : null,
	id: null,
	editable: null,
	back: false,
	initialize: function (options) {
		//Set the instance in this variable, in order to reuse it inside other local instances
		var self = this;

		//We get the id which was sent from the previous page. ID could be set or not (null).
		//If the id is null, it means that the view must be setup to add new model
		//else, it means that we need to fetch the detail of the specific model.
		this.id = options ? options.id : null;

		//if id is set
	    if(this.id)
		{
			//Create editable which we will send it with the template(render function).
			//This variable helps us recognize if the page was setup, in order to either add a new model
			//or to update an existing one.
			this.editable =  true ;
		}
		else
		{
			//Create editable which we will send it with the template(render function).
			//This variable helps us recognize if the page was setup, in order to either add a new model
			//or to update an existing one.
			this.editable =  false;
		}

		this.loadData();
	},
	loadData: function()
	{
		var self = this;

		if(this.editable)
		{
			//Create the new model with the id parameter. The parameter must be an object(JSON)
			this.model = new Model({id : this.id});

			//Fetch the data from server and add 'success' and 'error' callback to catch the response
			this.model.fetch({
				success: function(response)
				{
					//If it's all ok, we must call render to create the page(UI)
					self.render();
				},
				error: function(response, xhr, status)
				{
					if (xhr.status == 401) {
						window.open('./','_self');
					}else if(xhr.status == 403){
						window.open('./','_self');
					}
				}
			});
		}
		else
		{
			//Create the new model with no parameter because we want to add a new model
			this.model = new Model();

			//We must call render to create the page(UI)
			this.render();
		}
	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();
		//Set the instance at this variable to reuse it inside other local instances
		var self = this;

		//We join the response data from fetch and the editable data
		var data = $.extend(this.model.toJSON(), { editable: this.editable });

		//With this code, we put inside at $el(this was set up at the beginning of the object) the template of the view
		//this.template(data)) like this we send the data at the template
		this.$el.html(this.template(data));
	},
	events: {
        "click #submitBtn": "clickOnSubmit",
        "click #submitBack": "clickOnSubmitBack",
        "click #cancel": "onCancel",
        "click #reset": "clickOnReset",
        "click #delete": "onDelete",
	},
	checkTellodyApiKey: function() {
        var has_error = false;
        this.tellodyApiKey = $("#tellody_api_key").find("input").val().trim();

        if (this.tellodyApiKey != "" ) {
            if (!this.tellodyApiKey.match(/^([0-9]+)-([A-Za-z0-9]{16})$/)) {
                this.setError($("#tellody_api_key"), i18n.t("organization.invalid_apikey"));
                has_error = true;
            }
            else
                this.clearError($("#tellody_api_key"));
        }

        return has_error;
    },
	clickOnSubmitBack: function(e)
    {
        this.back = true;
        this.clickOnSubmit(null);
    },
	clickOnSubmit: function(e)
    {
		var self = this;

		//This is a dynamic way to validate data.
		//We create an object where the key is the #id of the element at the template.
		//The Value now is an array where we put the needed validation methods(We created it at the generic model)
		// { name: [this.isEmpty]}
		//isEmpty is the method. This method was written at the generic view
		var fields = {
			name: [this.isEmpty]
		};

		//When the object with all needed validation is set up,
		//then we call the method 'validateFields' from the generic model
		//and dynamically validate all data
		//and return false if one data field is wrong or true
		var has_error = this.validateFields(fields);
        var has_error2 = this.checkTellodyApiKey();
        this.description = $("#description").find("textarea").val().trim();
		//if "has_error" is true then proceed to update/add model
		if(!has_error && !has_error2)
		{
            //We set the new data, which the user changed it, to the model
			this.model.set("name", $("#name").find("input").val().trim());
			this.model.set("englishName", $("#englishName").find("input").val().trim());

			if(this.description != "" && this.description != undefined)
			    this.model.set("description", $("#description").find("textarea").val().trim());
			else
			    this.model.set("description", null);
			if ( this.tellodyApiKey != "" && this.tellodyApiKey != undefined)
			    this.model.set("tellodyApiKey", $("#tellody_api_key").find("input").val().trim());
			else
                this.model.set("tellodyApiKey", null);

            var queueLimit = $("#queueLimit").find("input").val().trim().length > 0 ? $("#queueLimit").find("input").val().trim() : null;
            this.model.set("queueLimit", queueLimit);

			//We show the generic progress bar to inform user that the procedure of update/add is working
			this.showActionProgressBar();

            $.when(window.ping()).then(function(resp) {
                $.ajaxSetup({
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                    }
                });

                //Say the model to execute the operation and we put callback to catch the response
                self.model.save(null, {
                    success: function(response) {
                        //Hide the generic progress bar
                        self.hideActionProgressBar();
                        if(self.editable)
                        {
                            //Notify the user that the operation 'update' was successful
                            $.notify(i18n.t("organization.organization_updated"), { position:"top center", className: "success" });

                            if(self.back)
                                self.goBack();
                            self.back = false;
                        }
                        else
                        {
                            //Notify the user that the operation 'add' was successful
                            $.notify(i18n.t("organization.organization_added"), { position:"top center", className: "success" });
                            self.goBack();
                        }
                    }
                });
            });


		}
		else {
			//Inform user to see the error and correct it
			$.notify(
				i18n.t("account.check_errors"),
				{ position:"top center", className: "error" }
			);
		}
    },
    //Run cancel method when Cancel button is pressed
	onCancel: function()
    {
       this.goBack();
    },
    clickOnReset: function(e)
    {
        $("#name").find("input").val("");
        $("#description").find("textarea").val("");
    },
    onDelete: function()
    {
    	var self = this;
		var organization_name = self.model.get("name");
    	dhtmlx.confirm({
			type: "confirm",
			text: i18n.t("organization.confirm_delete")+" \"" + organization_name + "\" ?",
			ok: "Delete",
			cancel: "Cancel",
			callback: function (result) {
				//if yes -> delete the organization and return to organizations page
				if (result) {
				    self.showActionProgressBar();
					self.model.destroy( {
                        success: function(response){
                            self.hideActionProgressBar();

                            $.notify(i18n.t("organization.organization")+" \"" +  organization_name + "\" "+ i18n.t("organization.was_deleted"), { position:"top center", className: "success" });
                            self.onCancel();
                        }
				   	});
				}
			}
		});
    }
});

